export const BATTERY_TIRE = 'battery-tire';

export const PART_CV_CONFIG_API_PATH = '/api/cv-part-config';
export const PART_LCV_CONFIG_API_PATH = '/api/lcv-part-config';
export const PART_API_PATH = '/api/part-items';
